/**
 * 좌석 상태를 문자열로 직렬화
 * @param seatStatus 2차원 배열 (number[][])
 * @param rowSep row 사이 구분자 (기본값: ' ')
 * @param colSep col 사이 구분자 (기본값: ',')
 * @returns 직렬화된 문자열
 */
export function serializeSeatStatus(
    seatStatus: number[][],
    rowSep: string = ' ',
    colSep: string = ','
): string {
    if (!seatStatus || seatStatus.length === 0) return ''
    return seatStatus
        .map(row => (row && row.length ? row.join(colSep) : '')) // 빈 행도 빈 문자열로 처리
        .join(rowSep)
}

/**
 * 문자열을 다시 seatStatus로 역직렬화
 * @param serialized 직렬화된 문자열
 * @param rowSep row 사이 구분자 (serializeSeatStatus와 동일해야 함)
 * @param colSep col 사이 구분자
 * @returns 2차원 배열 (number[][])
 */
export function deserializeSeatStatus(
    serialized: string,
    rowSep: string = ' ',
    colSep: string = ','
): number[][] {
    if (!serialized) return [] // 빈 문자열이면 빈 배열 반환

    return serialized.split(rowSep).map(row => {
        if (!row) return [] // 빈 문자열이면 빈 행으로 처리
        return row.split(colSep).map(num => Number(num))
    })
}
